import React from 'react';

// Full-page drop-hint overlay shown while files are dragged over the page. It's
// purely a visual affordance — pointerEvents:none so the actual drop is handled
// by the window listener in usePageFileDrop.
const FileDropOverlay: React.FC<{ show: boolean; label?: string }> = ({ show, label = 'Drop files to upload' }) => {
  if (!show) return null;
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ zIndex: 2000, background: 'rgba(13,110,253,0.12)', border: '4px dashed #0d6efd', pointerEvents: 'none' }}
    >
      <div className="bg-white rounded-3 shadow px-4 py-3 fs-5 text-primary">
        <i className="bi bi-cloud-arrow-up me-2" />
        {label}
      </div>
    </div>
  );
};

export default FileDropOverlay;
